export const MAX_ATTEMPTS = 180;
export const INTERVAL_TIME = 2000;
